import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FeatureCard from "./index";
import { Shield, Rocket, RotateCcw, Headphones } from "lucide-react";
import "./style.css";

const WhyChooseUs = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const animatedElements = entry.target.querySelectorAll(
              '[data-animate="true"]'
            );
            animatedElements.forEach((el) => {
              el.classList.add("animate-fade-in");
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="why-choose-us-section">
      <Container>
        <Row className="justify-content-center">
          <Col
            xs={12}
            className="text-center"
            data-animate="true"
            style={{ opacity: 0 }}
          >
            {/* <h2 className="section-title">
              Why Choose <span className="text-brand">Our Service</span>
            </h2> */}
            {/* <div className="section-divider"></div> */}
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={6} lg={3} className="mb-4">
            <FeatureCard
              icon={<Rocket className="feature-icon" />}
              title="Fast Shipping"
              description={
                <>
                  {/* Shipping available for equipment rentals within a{" "}
                  <span className="highlight-purple">150 miles</span> of site
                  location. Rates vary. */}
                  Same-day shipping until 3PM CST, with expedited options
                  available.
                </>
              }
              iconBgColor="var(--feature-purple-light)"
              borderColor="var(--feature-purple)"
              delay={0}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="mb-4">
            <FeatureCard
              icon={<RotateCcw className="feature-icon" />}
              title="Easy Return
"
              description={
                <>
                  {/* All equipment is shown within{" "}
                  <span className="highlight-green">
                    the photos of the actual equipment you're renting.{" "}
                  </span>
                  we do not use generic stock images. what you see is what you
                  get. */}
                  14-Day Return on select items. See item guarantees for details
                  and our terms and conditions.
                </>
              }
              iconBgColor="var(--feature-green-light)"
              borderColor="var(--feature-green)"
              delay={200}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="mb-4">
            <FeatureCard
              icon={<Shield className="feature-icon" />}
              title="100% Secure Payment
"
              description={
                <>
                  Shop with confidence knowing that your transactions are safe
                  and fully encrypted.
                </>
              }
              iconBgColor="var(--feature-blue-light)"
              borderColor="var(--feature-blue)"
              delay={300}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="mb-4">
            <FeatureCard
              icon={<Headphones className="feature-icon" />}
              title="Rapid Support"
              description={
                <>
                  Our customer service team is available round the clock to
                  assist you with any inquiries.
                </>
              }
              iconBgColor="var(--feature-orange-light)"
              borderColor="var(--feature-orange)"
              delay={400}
            />
          </Col>
        </Row>
        <Col lg={12} className="mb-5">
          <div className="return-container">
            <p className="text-left m-3 text-muted return-text">
              All sales are <strong>FOB Del Rio, TX,</strong> with the{" "}
              <strong>venue</strong> for this transaction in{" "}
              <strong>Val Verde County, TX</strong>. The customer is solely
              responsible for all{" "}
              <strong>
                shipping and packaging fees, including those for returns or
                exchanges
              </strong>
              . By placing an order, the customer agrees to these terms and to
              our Sales Order Terms & Conditions.{" "}
              <strong>A 3% processing fee</strong> applies to credit card orders{" "}
              <strong>exceeding $3,500</strong> in total.
            </p>
          </div>
        </Col>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
